/**
 * Fees API - Endpoints for system fees and agent commissions
 */
import apiClient from './client';

export interface FeeTrend {
    date: string;
    system: number;
    agent: number;
}

export interface FeeStatsResponse {
    total_fees: number;
    system_fees: number;
    agent_commissions: number;
    transaction_count: number;
    period: string;
    trends: FeeTrend[];
}

export interface FeeDetail {
    id: string;
    transaction_id: string;
    transaction_type: string;
    frais_total: string;
    frais_system: string;
    frais_agent: string;
    compte_id: string;
    compte_code: string;
    created_by_id: string;
    created_by_role: string;
    created_at: string;
}

export interface FeeListResponse {
    count: number;
    next: string | null;
    previous: string | null;
    results: FeeDetail[];
}

export const feesApi = {
    /**
     * Get fee dashboard statistics
     */
    async getFeeStats(period: 'week' | 'month' | 'year' = 'month'): Promise<FeeStatsResponse> {
        const response = await apiClient.get('/api/transactions/fees/dashboard/', {
            params: { period }
        });
        return response.data;
    },

    /**
     * List all fee records with filters
     */
    async listFees(params?: {
        page?: number;
        compte_id?: string;
        date_debut?: string;
        date_fin?: string;
    }): Promise<FeeListResponse> {
        const response = await apiClient.get('/api/transactions/fees/list/', { params });
        return response.data;
    }
};

export default feesApi;
